module.exports = __webpack_public_path__ + "static/media/ic_allow_sel.a0fe9827.svg";